import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

import { useGetGithubTeams } from './useGetGithubTeams';

export type GithubTeamPickerUiOptions = {
  allowedValues?: string[];
};

export const GithubTeamPickerExtension = (
  props: FieldExtensionComponentProps<string, GithubTeamPickerUiOptions>,
) => {
  const {
    onChange,
    schema: { title = '', description = '' },
    required,
    uiSchema,
    rawErrors,
    formData,
    idSchema,
  } = props;

  const onSelect = (_: any, value: string | null) => {
    onChange(value || '');
  };

  const allowedValues: string[] = uiSchema['ui:options']?.allowedValues || [];
  const { value: teams } = useGetGithubTeams();

  const allowedTeams =
    allowedValues.length > 0
      ? (teams ?? []).filter(team => allowedValues.includes(team))
      : teams ?? [];

  return (
    <FormControl
      variant="standard"
      margin="normal"
      required={required}
      error={rawErrors?.length > 0 && !formData}
    >
      <Autocomplete
        id={idSchema?.$id}
        value={(formData as string) || null}
        onChange={onSelect}
        options={allowedTeams}
        renderInput={params => (
          <TextField
            {...params}
            label={title}
            margin="normal"
            helperText={description}
            variant="outlined"
            required={required}
          />
        )}
      />
    </FormControl>
  );
};
